module.exports = __webpack_public_path__ + "img/叹号.bd5ffa26.png";